import { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';

export const useOperational = (country) => {
  const [notifications, setNotifications] = useState([]);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  const loadNotifications = useCallback(async () => {
    try {
      const data = await api.getOperational(country);
      setNotifications(data.items || []);
    } catch (error) {
      console.error('Error loading operational notifications:', error);
    }
  }, [country]);

  const refresh = () => {
    setLastUpdate(new Date());
    loadNotifications();
  };

  useEffect(() => {
    loadNotifications();
  }, [loadNotifications]);

  return {
    notifications,
    lastUpdate,
    loadNotifications,
    refresh
  };
}
